(function () {
  function isRevocationTrigger(anchor) {
    if (!anchor || anchor.tagName !== 'A') return false;

    const href = anchor.getAttribute('href');
    if (href === '#widerruf') return true;

    try {
      return new URL(anchor.href, window.location.href).hash === '#widerruf';
    } catch {
      return false;
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('a');
    if (!isRevocationTrigger(trigger)) return;

    const button = document.getElementById('hbRevocationButton');
    if (!button) return;

    event.preventDefault();

    if (typeof button.onclick === 'function') {
      button.click();
      return;
    }

    if (button.href) {
      window.open(button.href, '_blank', 'noopener');
    }
  });
})();
